import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { UseAlert } from '../../../presentation/hook/AlertHook';
import { UseLoader } from '../../../presentation/hook/LoaderHook';

import { PaginationType } from '../../contract/Pagination';

import { PrivateRoutes } from '../../../main/constant/RouteConstant';

import { PatientUseCase } from '../../../data/useCase/PatientUseCase';

import { InputsSearchPatient } from '../../../presentation/page/listPatient/ListPatientPageType';

import ListPatientPage from '../../../presentation/page/listPatient/ListPatientPage';
import MessageConstant from '../../../main/constant/MessageConstant';
import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * ListPatientPageDomain - regra de negocio de listagem Paciente
 * @constructor
 */
export const ListPatientPageDomain: React.FC = () => {
  /**
   * loading
   */
  const { setLoad } = UseLoader();

  let PAGE = 0;
  let PAGE_SIZE = 15;
  let STATUS = 'Ativos';

  /**
   * endpoint
   */
  const ENDPOINT_PATIENT = EndpointsConstant.patient;

  /**
   * navegacao da url
   */
  let navigate = useNavigate();

  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * model
   */
  const [list, setList] = useState<[]>([]);

  /**
   * paginacao
   */
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  /**
   * add
   */
  const add = () => {
    navigate(PrivateRoutes.ADD_PATIENT);
  };

  /**
   * getList
   */
  const getList = async () => {
    setLoad(true);
    setPagination(null);

    await new PatientUseCase(`${ENDPOINT_PATIENT}/?page=${PAGE}&pageSize=${PAGE_SIZE}&status=${STATUS}`)
      .Get()
      .then((response: any) => {
        setList(response.body.items);

        if (response.body.totalPages > 1) {
          setPagination({
            pageIndex: response.body.pageIndex,
            pageSize: response.body.pageSize,
            totalCount: response.body.totalCount,
            totalPages: response.body.totalPages,
            hasPreviousPage: response.body.hasPreviousPage,
            hasNextPage: response.body.hasNextPage,
            onClickItem: handleClickPagination,
          });
        }
      })
      .catch((error) => {
        showAlert({
          show: true,
          content: MessageConstant.erro.generico,
          color: 'danger',
          time: 2000,
        });
        console.error('ERRO: ', error);
      });
    setLoad(false);
  };

  /**
   * remove
   * @param id
   */
  const remove = async (id: number) => {
    setLoad(true);
    await new PatientUseCase(`${ENDPOINT_PATIENT}/${id}`)
      .Delete()
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    await getList();
    setLoad(false);
  };

  /**
   * toggle
   * @param id
   */
  const toggle = async (id: number) => {
    setLoad(true);
    STATUS = 'Ativos';
    await new PatientUseCase(`${ENDPOINT_PATIENT}/${id}/reactivate`)
      .Put()
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    navigate(PrivateRoutes.LIST_PATIENT);

    await getList();
    setLoad(false);
  };

  /**
   * edit
   * @param id
   */
  const edit = (id: number) => {
    navigate(`${PrivateRoutes.ADD_PATIENT}/${id}`);
  };

  /**
   * searchPatient
   * @param params
   */
  const searchPatient = async (params: InputsSearchPatient) => {
    STATUS = params.status;
    setLoad(true);
    setPagination(null);
    await new PatientUseCase(`${ENDPOINT_PATIENT}/?page=${PAGE}&pageSize=${PAGE_SIZE}&name=${params.nome}&status=${params.status}`)
      .Get()
      .then((response) => {
        setList(response.body.items);
        if (response.body.totalPages > 1) {
          setPagination({
            pageIndex: response.body.pageIndex,
            pageSize: response.body.pageSize,
            totalCount: response.body.totalCount,
            totalPages: response.body.totalPages,
            hasPreviousPage: response.body.hasPreviousPage,
            hasNextPage: response.body.hasNextPage,
            onClickItem: handleClickPagination,
          });
        }
      })
      .catch((error) => {
        showAlert({
          show: true,
          content: MessageConstant.erro.generico,
          color: 'danger',
          time: 2000,
        });
        console.error('ERRO: ', error);
      });
    setLoad(false);
  };

  /**
   * handleClickPagination
   * @param id
   */
  const handleClickPagination = async (id: number) => {
    PAGE = id;
    getList();
  };

  /**
   *
   */
  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <ListPatientPage add={add} list={list} remove={remove} edit={edit} search={searchPatient} pagination={pagination} toggle={toggle} />
    </>
  );
};
